/*
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software distributed
  under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
  CONDITIONS OF ANY KIND, either express or implied. See the License for the
  specific language governing permissions and limitations under the License.
*/

import Button, { ButtonProps } from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";

const useStyles = makeStyles(theme => ({
  root: (props: ButtonProps) => {
    if (props.variant === "contained") {
      return {
        color: theme.palette.error.contrastText,
        backgroundColor: theme.palette.error.main,
        "&:hover": {
          backgroundColor: theme.palette.error.dark
        }
      };
    }

    if (props.variant === "outlined") {
      return {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main,
        "&:hover": {
          color: theme.palette.error.dark,
          borderColor: theme.palette.error.dark
        }
      };
    }

    return {
      color: theme.palette.error.main,
      "&:hover": {
        color: theme.palette.error.dark
      }
    };
  }
}));

export const ErrorButton = (props: ButtonProps) => {
  const classes = useStyles(props);

  return (
    <Button
      {...props}
      className={`${classes.root} ${props.className} marapp-qa-error-button`}
    />
  );
};

export default ErrorButton;
